export const ENV_PRODUCTION = 'production';
export const ENV_DEVELOPMENT = 'development';
export const ENV_HOMOLOG = 'homolog';

export const BASE_PLATAFORMA = 'https://plataforma.txaiacademia.com.br';

export const PRODUCT_IMG_DEFAULT = 'https://cdn.txaiacademia.com.br/images/produtos/produto-sem-imagem.png';
